import { EditorState, Transaction } from "prosemirror-state";
import {deleteTable, removeRow, TableMap} from "prosemirror-tables";
import {EditorView} from "prosemirror-view";

import type {TableContextMenuParams} from "../../../../ui/elements/context-menu/editor/TableToolbar/openTableContextMenu";

import {isPosInTable} from "../../../utils/table/isPosInTable";
import {getInTableRect} from "../../../utils/table/getInTableRect";
import {getNearestCellPos} from "../../../utils/table/getNearestCellPos";

export const deleteRow = (state: EditorState, dispatch?: (tr: Transaction) => void, view?: EditorView, params?: TableContextMenuParams): boolean => {
    let targetPos = state.selection.$from.pos;
    if (params?.clickPos) {
        targetPos = params.clickPos;
    }
    const $pos = getNearestCellPos(state.doc.resolve(targetPos));
    if (!$pos || !isPosInTable($pos)) {
        return false;
    }

    if (dispatch) {
        const info = getInTableRect($pos);
        const tr = state.tr;

        if (info.top === 0 && info.bottom === info.map.height) {
            return deleteTable(state, dispatch);
        }

        for (let i = info.bottom - 1; ; i--) {
            removeRow(tr, info, i);
            if (i === info.top) {
                break;
            }

            info.table = info.tableStart ? tr.doc.nodeAt(info.tableStart - 1)! : tr.doc;
            info.map = TableMap.get(info.table)
        }

        if (tr.steps.length > 0) {
            dispatch(tr);
        }
    }

    return true;
}
